import {
  toThreeDecimals,
  toTwoDecimals,
} from "../components/NewDetail/calculations/utils";

const getLaborSummary = (order) => {
  let data = {};
  let totalHours = 0;

  let orderItems = order.items;

  for (let orderItem of orderItems) {
    switch (orderItem.objectType) {
      case "Coil":
        let coil = orderItem;

        break;
      case "FlatSheet":
        let flatSheet = orderItem;

        break;
      case "Panel":
        let panel = orderItem;
        if (panel) {
          let panelHours = Number(
            panel?.calculations?.estimatedLaborHours ?? 0
          );
          totalHours += panelHours;
          data.panelHours = panelHours;
        }
        break;
      case "TrimAndFlashing":
        let trimAndFlashing = orderItem;
        if (trimAndFlashing) {
          let trimHours = Number(
            trimAndFlashing?.trimCalculations?.estimatedLaborHours ?? 0
          );
          totalHours += trimHours;
          data.trimHours = trimHours;
        }
        break;
      case "CopingCap":
        let copingCap = orderItem;
        if (copingCap) {
          let copingCapHours = Number(
            copingCap?.trimCalculations?.estimatedLaborHours ?? 0
          );
          totalHours += copingCapHours;
          data.copingCapHours = copingCapHours;
        }
        break;
      case "CopingCapCleat":
        let cleat = orderItem;
        if (cleat) {
          // cleatTotals = getCleatTotals(cleat);
          let cleatHours = Number(
            cleat?.trimCalculations?.estimatedLaborHours ?? 0
          );
          totalHours += cleatHours;
          data.cleatHours = cleatHours;
        }
        break;
      case "BenchWork":
        let benchwork = orderItem;
        if (benchwork) {
          let benchWorkHours = Number(
            benchwork?.benchWorkCalculations?.totalEstimatedLaborHours ?? 0
          );
          totalHours += benchWorkHours;
          data.benchWorkHours = benchWorkHours;
        }
        break;
      case "SplicePlate":
        let splicePlate = orderItem;
        if (splicePlate) {
          let splicePlateHours = Number(
            splicePlate?.trimCalculations?.estimatedLaborHours ?? 0
          );
          totalHours += splicePlateHours;
          data.splicePlateHours = splicePlateHours;
        }
        break;
      case "Accessory":
        break;
      default:
        break;
    }
  }

  data.totalHours = toTwoDecimals(totalHours);

  return data;
};

export default getLaborSummary;
